<template>
  <div class="left greal-left">
    <!--左侧栏-->
    <el-row :sysName="sysName" class="tac">
      <el-col :span="24">
        <el-menu
          :default-active="active"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="#122e5e"
          text-color="#65799b"
          :router="true"
          :unique-opened="true"
          active-text-color="#fff">
          <!--增加首页-->
          <el-menu-item :route="{name:'EntryPage'}" index="EntryPage">
            <span class="iconfont icon-shouye menuIcon"></span>
            <span slot="title"><a class="jump Difjump" href="javascript:void(0)">首页</a></span>
          </el-menu-item>
          <el-submenu index="DataCenter">
            <template slot="title">
              <span class="iconfont icon-ziliaozhongxin menuIcon"></span>
              <span>资料中心</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :route="{name:'HospitalImage'}" index="HospitalImage"><a class="jump" href="javascript:void(0)">本院影像</a><i class="arrow">></i></el-menu-item>
              <el-menu-item :route="{name:'MedicalRecord'}" index="MedicalRecord"><a class="jump" href="javascript:void(0)">典型病例库</a><i class="arrow">></i></el-menu-item>
              <el-menu-item :route="{name:'CourseWare'}" index="CourseWare"><a class="jump" href="javascript:void(0)">教学课件</a><i class="arrow">></i></el-menu-item>
              </el-menu-item>
            </el-menu-item-group>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="ManageMeeting">
            <template slot="title">
              <span class="iconfont icon-huiyiguanli menuIcon"></span>
              <span>读片管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :route="{name:'DailyMeeting'}" index="DailyMeeting"><a class="jump" href="javascript:void(0)">每日读片</a><i class="arrow">></i></el-menu-item>
              <el-menu-item :route="{name:'ManageMeeting'}" index="ManageMeeting"><a class="jump" href="javascript:void(0)">专题读片</a><i class="arrow">></i></el-menu-item>
              </el-menu-item>
            </el-menu-item-group>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item :route="{name:'TeachManage'}" index="TeachManage">
            <span class="iconfont icon-jiaoxueguanli menuIcon"></span>
            <span slot="title"><a class="jump Difjump" href="javascript:void(0)">教学管理</a></span>
          </el-menu-item>
          <el-menu-item :route="{name:'TeachCenter'}" index="TeachCenter">
            <span class="iconfont icon-jiaoxuezhongxin menuIcon"></span>
            <span slot="title"><a class="jump Difjump" href="javascript:void(0)">教学中心</a></span>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script type="text/ecmascript-6">
  import {getActive} from '@/common/js/active'
  export default {
    name: 'Homepage',
    data () {
      return {
        active: ''
      }
    },
    props: {
      sysName: {
        type: String,
        default: ''
      }
    },
    mounted() {
      setTimeout(() => {
        this._getLeftH()
      }, 20)

      window.addEventListener('resize', () => {
        this._getLeftH()
      })
    },
    methods: {
      handleOpen(key, keyPath) {
        // console.log(key, keyPath)
      },
      handleClose(key, keyPath) {
        // console.log(key, keyPath)
      },
      _getLeftH() {
        let height = document.getElementById('app').clientHeight
        let left = document.getElementsByClassName('left')
        left[0].style.height = height + 'px'
      },
      _getActive() {
        let act = this.$route.matched[1].path.split('/')
        this.active = act[2]
      }
    },
    created() {
      this._getActive()
    },
    watch:{

      //监听router 自动展开对应的导航栏
      $route(to,from){

        if(to.name === "newMedicalRecord"){
          this.active="MedicalRecord";
        }else if(to.name === "AddCourseWare"){
          this.active="CourseWare";
        }else if(to.name === "NewCourse" ||to.name ===  "LookCourse"){
          this.active="TeachManage";
        }else if(to.name === "AddManageMeeting" || to.name === "EnterManageMeeting" || to.name ==="QueryManageMeeting"){
          this.active="ManageMeeting";
        }else if(to.name === "DailyDetail"){
           this.active="DailyMeeting";
        }else{
          this.active=to.name;
        }
      }
    },
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .systemLogo
    height: 50px
    background: #122248
    overflow: hidden
    .logoText
      line-height: 50px
      color: $color-index-text
      font-size: $font-size-medium-x
      float: left
    .logoImg
      width: 30px
      height: 30px
      margin: 10px 13px
      float: left
      border-radius: 50%
  .left
    height: 100%
    background: $color-background-d-left
    overflow-y: auto
    overflow-x: hidden

  .text-color
    color: $color-text

  .greal-left
    width: 180px
    float: left

</style>



// WEBPACK FOOTER //
// leftMenu.vue?3791596f